module.exports = __webpack_public_path__ + "static/img/halifax3.57bd9cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/halifax3.jpg
// module id = 95
// module chunks = 9